import { render } from "./serviceRequest.vue?vue&type=template&id=3c9e4bdb&scoped=true"
import script from "./serviceRequest.vue?vue&type=script&lang=js"
export * from "./serviceRequest.vue?vue&type=script&lang=js"

import "./serviceRequest.vue?vue&type=style&index=0&id=3c9e4bdb&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9e4bdb"]])

export default __exports__